
const ThailandFlag = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="23" height="17" viewBox="0 0 23 17" fill="none">
            <rect x="0.75" y="0.75" width="21.5" height="15.5" rx="1.75" fill="white" stroke="#F5F5F5" strokeWidth="0.5" />
            <mask id="mask0_1325_7411" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x="0" y="0" width="23" height="17">
                <rect x="0.75" y="0.75" width="21.5" height="15.5" rx="1.75" fill="white" stroke="white" strokeWidth="0.5" />
            </mask>
            <g mask="url(#mask0_1325_7411)">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 3.7H22.5V0.5H0.5V3.7Z" fill="#F12532" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 16.4998H22.5V13.2998H0.5V16.4998Z" fill="#F12532" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 11.1668H22.5V5.8335H0.5V11.1668Z" fill="#322B6C" />
            </g>
        </svg>
    )
}

export default ThailandFlag